<template>
  <SectionTemplate title="无需真人出镜，好莱坞级3D数字人帮你生动演绎" subTitle="3D AI 数字人">
    <div class="card-list">
      <FeatureCard
        v-for="(feature, index) in featureList"
        :key="index"
        v-bind="feature"
        btnText="免费试用"
        :action="handleTrail"
      />
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import FeatureCard from '@/design/components/feature-card/index.vue';
import { useBreakpoint } from '@rendora/design/index';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';
import { getFeUrl } from '~/utils/url';

const headers = useRequestHeaders();
const { isMobile } = useBreakpoint(headers?.['user-agent']);

const featureList = computed(() => [
  {
    title: isMobile.value
      ? `数千款好莱坞级3D数字人 谁来出镜由你决定`
      : `数千款好莱坞级3D数字人 \n谁来出镜由你决定`,
    description:
      '3000+好莱坞级3D数字人，覆盖各年龄段、族裔与风格，无论是专业正式还是亲切自然，总有一款适合你。每个角色都以好莱坞电影级标准打造，皮肤、发丝、妆造、衣物等各类细节都能真实还原、专业呈现。',
    video: getFeUrl('/youyan-platform/main/avatar-feature/1.webm'),
    image: getFeUrl('/youyan-platform/main/avatar-feature/1.png?x-oss-process=image/format,webp'),
    videoDesc: '查看有言提供的数千款好莱坞级3D数字人',
  },
  {
    title: isMobile.value
      ? `个性化形象编辑 轻松打造你的专属数字人形象`
      : `个性化形象编辑
轻松打造你的专属数字人形象`,
    description:
      '想要拥有风格鲜明、独一无二的数字人形象？你可以自定义五官、发型、妆容、服饰与配饰，还可添加品牌Logo，打造出真正属于你的3D数字人形象。',
    video: getFeUrl('/youyan-platform/main/avatar-feature/2.webm'),
    image: getFeUrl('/youyan-platform/main/avatar-feature/2.png?x-oss-process=image/format,webp'),

    reverse: true,
    videoDesc: '有言提供3D数字人的个性化编辑功能',
  },
  {
    title: isMobile.value
      ? `AI生成语音与动作 赋予数字人自然生动的表达力`
      : `AI生成语音与动作
赋予数字人自然生动的表达力`,
    description:
      '只需输入一段文字，AI 即可生成声音、表情和动作，让 3D 数字人像你一样声情并茂地传递信息，轻松应对培训、演讲、营销等多种视频场景。',
    video: getFeUrl('/youyan-platform/main/avatar-feature/3.webm'),
    videoDesc: '有言可以通过AI让数字人生动地展示动作和表情',
    image: getFeUrl('/youyan-platform/main/avatar-feature/3.png?x-oss-process=image/format,webp'),
  },
  {
    title: isMobile.value
      ? `一键切换多语种视频 快速拓展海外市场`
      : `一键切换多语种视频
快速拓展海外市场`,
    description:
      '无需聘请翻译或外语配音演员，有言支持英语、西语、法语、日语等百余种语言与方言，提供一键翻译与自然流畅的语音播报。企业可高效批量生成多语言视频，以更低成本、更快速度，触达全球市场。',
    video: getFeUrl('/youyan-platform/main/avatar-feature/4.webm'),
    reverse: true,
    videoDesc: '有言提供数十种AI数字人音色和语言满足海外市场需求',
    image: getFeUrl('/youyan-platform/main/avatar-feature/4.png?x-oss-process=image/format,webp'),
  },
]);

const handleTrail = () => {
  emit('trial');
};

const emit = defineEmits<{
  (e: 'trial'): void;
}>();
</script>

<style lang="scss" scoped src="./pc.scss" />
<style lang="scss" scoped src="./mobile.scss" />
